import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const listDestinations = () => api.get("/destinations").then((r) => r.data.destinations);
export const getDestination = (slug) => api.get(`/destinations/${slug}`).then((r) => r.data);
export const createInquiry = (payload) => api.post("/inquiries", payload).then((r) => r.data);
export const listInquiries = (token) =>
  api.get("/inquiries", { headers: { "x-admin-token": token } }).then((r) => r.data.inquiries);
export const updateInquiryStatus = (id, status, token) =>
  api
    .patch(`/inquiries/${id}`, { status }, { headers: { "x-admin-token": token } })
    .then((r) => r.data);
export const adminStats = (token) =>
  api.get("/admin/stats", { headers: { "x-admin-token": token } }).then((r) => r.data);
export const sendQuoteMessage = (payload) =>
  api.post("/ai/quote/chat", payload).then((r) => r.data);
export const getQuoteSession = (sessionId) =>
  api.get(`/ai/quote/session/${sessionId}`).then((r) => r.data);
export const finalizeQuote = (payload) =>
  api.post("/ai/quote/finalize", payload).then((r) => r.data);
